import styles from './DiagSpinner.module.css'

interface DiagSpinnerProps {
  size?: 'small' | 'default' | 'large'
  inline?: boolean
  /** Optional caption rendered below the spinner. Replaces antd Spin's `tip`. */
  tip?: string
}

export default function DiagSpinner({ size = 'default', inline, tip }: DiagSpinnerProps) {
  const containerClass = [
    styles.container,
    size === 'small' && styles.small,
    inline && styles.inline,
  ]
    .filter(Boolean)
    .join(' ')

  const spinnerClass = [
    styles.spinner,
    size === 'small' && styles.spinnerSmall,
    size === 'large' && styles.spinnerLarge,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={containerClass} role="status" aria-label={tip ?? 'Loading'}>
      <div className={spinnerClass} />
      {tip && <span className={styles.tip}>{tip}</span>}
    </div>
  )
}
